import React from 'react';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import style from '../../../styles/styles';
import PropTypes from 'prop-types';
import {grey400} from 'material-ui/styles/colors';
import {Link} from "react-router-dom";
import {ListItem} from 'material-ui/List';
import AdminService, {SUPER_ADMIN} from "../../../services/admin";
import withTranslation from "../../../hoc/withTranslation";
import {EDIT_CF_PAGE} from "../../../constants/routes";

class CustomField extends React.Component {

    static propTypes = {
        customField: PropTypes.object.isRequired,
        app: PropTypes.object,
        user: PropTypes.object,
        handleRemoveCustomField: PropTypes.func
    };

    handleRemoveCustomField = () => {
        this.props.handleRemoveCustomField(this.props.customField);
    };

    rightIconButton = () => {
        if (!this.props.user || !this.props.app) {
            return
        }

        const authorized = AdminService.isAuthorized(SUPER_ADMIN, this.props.user);

        if (!authorized) {
            return null;
        }

        const iconButtonElement = (
            <IconButton
                touch={true}
                tooltipPosition="bottom-left"
            >
                <MoreVertIcon color={grey400}/>
            </IconButton>
        );

        return (
            <IconMenu
                iconButtonElement={iconButtonElement}
                listStyle={style.list}
                anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                targetOrigin={{horizontal: 'right', vertical: 'top'}}
            >
                {authorized && (
                    <Link to={EDIT_CF_PAGE.replace(':appId', this.props.app.id).replace(':customFieldId', this.props.customField.id)}>
                        <MenuItem>
                            {this.props.t('generic.edit')}
                        </MenuItem>
                    </Link>
                )}
                {authorized && this.props.handleRemoveCustomField && (
                    <MenuItem onClick={this.handleRemoveCustomField}>
                        {this.props.t('generic.remove')}
                    </MenuItem>
                )}
            </IconMenu>
        )
    };

    render() {
        const {customField} = this.props;

        return (
            <ListItem
                primaryText={customField.name}
                secondaryText={customField.tag || "No tag"}
                rightIconButton={this.rightIconButton()}
            />
        );
    }
}

export default withTranslation(CustomField);



// WEBPACK FOOTER //
// src/components/customfield/CustomField/CustomField.js